{
  "labels": {
    "paste": "পেস্ট করুন",
    "pasteAsPlaintext": "প্লেইনটেক্সট হিসাবে পেস্ট করুন",
    "pasteCharts": "চার্ট পেস্ট করুন",
    "selectAll": "সবটা সিলেক্ট করুন",
    "multiSelect": "একাধিক সিলেক্ট করুন",
    "moveCanvas": "ক্যানভাস সরান",
    "cut": "কাট করুন",
    "copy": "কপি করুন",
    "copyAsPng": "পীএনজী ছবির মতন কপি করুন",
    "copyAsSvg": "এসভীজী ছবির মতন কপি করুন",
    "copyText": "লিখিত তথ্যের মতন কপি করুন",
    "copySource": "পিএনজি ছবি ক্লিপবোর্ডে কপি করুন",
    "convertToCode": "কোডে রূপান্তর করুন",
    "bringForward": "অধিকতর সামনে আনুন",
    "sendToBack": "অধিকতর পিছনে নিয়ে যান",
    "bringToFront": "সবার সামনে আনুন",
    "sendBackward": "সবার পিছনে নিয়ে যান",
    "delete": "মুছা",
    "copyStyles": "ডিজাইন কপি করুন",
    "pasteStyles": "ডিজাইন পেস্ট করুন",
    "stroke": "রেখাংশ",
    "changeStroke": "Hi",
    "background": "পটভূমি",
    "changeBackground": "পটভূমির রঙ পরিবর্তন করুন",
    "fill": "রং",
    "strokeWidth": "রেখাংশের বেধ",
    "strokeStyle": "রেখাংশের ডিজাইন",
    "strokeStyle_solid": "পুরু",
    "strokeStyle_dashed": "পাতলা",
    "strokeStyle_dotted": "বিন্দুবিন্দু",
    "sloppiness": "ভ্রান্তি",
    "opacity": "দৃশ্যমানতা",
    "textAlign": "লেখ অনুভূমি",
    "edges": "কোণ",
    "sharp": "তীক্ষ্ণ",
    "round": "গোল",
    "arrowheads": "তীরের শীর্ষভাগ",
    "arrowhead_none": "কিছু না",
    "arrowhead_arrow": "তীর",
    "arrowhead_bar": "রেখাংশ",
    "arrowhead_circle": "বৃত্ত",
    "arrowhead_circle_outline": "বৃত্তীয় (প্রান্তরেখা) প্রান্তরেখা",
    "arrowhead_triangle": "ত্রিভূজ",
    "arrowhead_triangle_outline": "ত্রিভুজ (প্রান্তরেখা) প্রান্তরেখা",
    "arrowhead_diamond": "হীরক",
    "arrowhead_diamond_outline": "হীরক (প্রান্তরেখা)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "লেখনীর মাত্রা",
    "fontFamily": "লেখনীর হরফ",
    "addWatermark": "এক্সক্যালিড্র দ্বারা প্রস্তুত",
    "handDrawn": "হাতে আঁকা",
    "normal": "স্বাভাবিক",
    "code": "কোড",
    "small": "ছোট",
    "medium": "মাঝারি",
    "large": "বড়",
    "veryLarge": "অনেক বড়",
    "solid": "দৃঢ়",
    "hachure": "ভ্রুলেখা",
    "zigzag": "আঁকাবাঁকা",
    "crossHatch": "ক্রস হ্যাচ",
    "thin": "পাতলা",
    "bold": "পুরু",
    "left": "বাম",
    "center": "কেন্দ্র",
    "right": "ডান",
    "extraBold": "অতি পুরু",
    "architect": "স্থপতি",
    "artist": "শিল্পী",
    "cartoonist": "চিত্রকার",
    "fileTitle": "ফাইলের নাম",
    "colorPicker": "রং পছন্দ করুন",
    "canvasColors": "ক্যানভাসের রং",
    "canvasBackground": "ক্যানভাসের পটভূমি",
    "drawingCanvas": "ব্যবহৃত ক্যানভাস",
    "clearCanvas": "পরিষ্কার ক্যানভাস",
    "layers": "মাত্রা",
    "actions": "ক্রিয়া",
    "language": "ভাষা",
    "liveCollaboration": "সরাসরি পারস্পরিক সহযোগিতা...",
    "duplicateSelection": "সদৃশ সিলেক্ট",
    "untitled": "অনামী",
    "name": "নাম",
    "yourName": "আপনার নাম",
    "madeWithExcalidraw": "এক্সক্যালিড্র দ্বারা তৈরি",
    "group": "দল গঠন করুন",
    "ungroup": "দল বিভেদ করুন",
    "collaborators": "সহযোগী",
    "toggleGrid": "",
    "addToLibrary": "সংগ্রহে যোগ করুন",
    "removeFromLibrary": "সংগ্রহ থেকে বের করুন",
    "libraryLoadingMessage": "সংগ্রহ তৈরি হচ্ছে",
    "libraries": "সংগ্রহ দেখুন",
    "loadingScene": "দৃশ্য তৈরি হচ্ছে",
    "loadScene": "",
    "align": "পংক্তিবিন্যাস",
    "alignTop": "উপর পংক্তি",
    "alignBottom": "নিম্ন পংক্তি",
    "alignLeft": "বাম পংক্তি",
    "alignRight": "ডান পংক্তি",
    "centerVertically": "উলম্ব কেন্দ্রিত",
    "centerHorizontally": "অনুভূমিক কেন্দ্রিত",
    "distributeHorizontally": "অনুভূমিকভাবে বিতরণ করুন",
    "distributeVertically": "উল্লম্বভাবে বিতরণ করুন",
    "flipHorizontal": "অনুভূমিক আবর্তন",
    "flipVertical": "উলম্ব আবর্তন",
    "viewMode": "দৃশ্য",
    "share": "ভাগ করুন",
    "showStroke": "",
    "showBackground": "পটভূমির রঙ নির্বাচনকারী অপশন দেখান",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "personalLib": "ব্যক্তিগত লাইব্রেরি",
    "excalidrawLib": "এক্সক্যালিড্র লাইব্রেরি",
    "decreaseFontSize": "লেখনীর মাত্রা কমান",
    "increaseFontSize": "লেখনীর মাত্রা বাড়ান",
    "unbindText": "লেখার জোড় খুলুন",
    "bindText": "কন্টেইনারের সাথে লেখা জোড়া লাগান",
    "createContainerFromText": "",
    "link": {
      "edit": "লিঙ্ক সংশোধন",
      "editEmbed": "",
      "create": "",
      "label": "লিঙ্ক নামকরণ",
      "labelEmbed": "লিংক ও এম্বেড",
      "empty": "কোন লিংক সেট করা নেই",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "লাইন সম্পাদনা করুন",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "আবদ্ধ করুন",
      "unlock": "বিচ্ছিন্ন করুন",
      "lockAll": "সব আবদ্ধ করুন",
      "unlockAll": "সব বিচ্ছিন্ন করুন"
    },
    "statusPublished": "প্রকাশিত",
    "sidebarLock": "লক",
    "selectAllElementsInFrame": "ফ্রেমের ভিতরের সব উপকরণ বাছাই করুন",
    "removeAllElementsFromFrame": "ফ্রেম থেকে সব উপকরণ মুছুন",
    "eyeDropper": "ক্যানভাস থেকে রঙ বাছাই করুন",
    "textToDiagram": "লেখা থেকে ডায়াগ্রাম",
    "prompt": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "সংগ্রহে কিছু যোগ করা হয়নি",
    "hint_emptyLibrary": "এখানে যোগ করার জন্য ক্যানভাসে একটি বস্তু নির্বাচন করুন, অথবা নীচে, প্রকাশ্য সংগ্রহশালা থেকে একটি সংগ্রহ ইনস্টল করুন৷",
    "hint_emptyPrivateLibrary": "এখানে যোগ করার জন্য ক্যানভাসে একটি বস্তু নির্বাচন করুন",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "ক্যানভাস সাফ করুন",
    "exportJSON": "জেসন নিবদ্ধ করুন",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "ক্লিপবোর্ডে কপি করুন",
    "copyLink": "",
    "save": "জমা করুন",
    "saveAs": "অন্যভাবে জমা করুন",
    "load": "",
    "getShareableLink": "ভাগযোগ্য লিঙ্ক পান",
    "close": "বন্ধ করুন",
    "selectLanguage": "ভাষা চিহ্নিত করুন",
    "scrollBackToContent": "বিষয়বস্তুতে ফেরত যান",
    "zoomIn": "বড় করুন",
    "zoomOut": "ছোট করুন",
    "resetZoom": "স্বাভাবিক করুন",
    "menu": "তালিকা",
    "done": "সম্পন্ন",
    "edit": "সংশোধন করুন",
    "undo": "ফেরত যান",
    "redo": "পুনরায় করুন",
    "resetLibrary": "সংগ্রহ সাফ করুন",
    "createNewRoom": "নতুন রুম বানান",
    "fullScreen": "পূর্ণস্ক্রীন",
    "darkMode": "ডার্ক মোড",
    "lightMode": "লাইট মোড",
    "systemMode": "",
    "zenMode": "জেন মোড",
    "objectsSnapMode": "",
    "exitZenMode": "জেন মোড বন্ধ করুন",
    "cancel": "বাতিল",
    "saveLibNames": "",
    "clear": "সাফ",
    "remove": "বিয়োগ",
    "embed": "",
    "publishLibrary": "",
    "submit": "জমা করুন",
    "confirm": "নিশ্চিত করুন",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "এটি পুরো ক্যানভাস সাফ করবে। আপনি কি নিশ্চিত?",
    "couldNotCreateShareableLink": "ভাগ করা যায় এমন লিঙ্ক তৈরি করা যায়নি।",
    "couldNotCreateShareableLinkTooBig": "ভাগ করা যায় এমন লিঙ্ক তৈরি করা যায়নি: দৃশ্যটি খুব বড়",
    "couldNotLoadInvalidFile": "অবৈধ ফাইল লোড করা যায়নি",
    "importBackendFailed": "ব্যাকেন্ড থেকে আপলোড ব্যর্থ হয়েছে।",
    "cannotExportEmptyCanvas": "খালি ক্যানভাস নিবদ্ধ করা যাবে না।",
    "couldNotCopyToClipboard": "ক্লিপবোর্ডে কপি করা যায়নি।",
    "decryptFailed": "তথ্য ডিক্রিপ্ট করা যায়নি।",
    "uploadedSecurly": "আপলোডটি এন্ড-টু-এন্ড এনক্রিপশনের মাধ্যমে সুরক্ষিত করা হয়েছে, যার অর্থ হল এক্সক্যালিড্র সার্ভার এবং তৃতীয় পক্ষের দ্বারা পড়তে পারা সম্ভব নয়।",
    "loadSceneOverridePrompt": "বাহ্যিক অঙ্কন লোড করা আপনার বিদ্যমান দৃশ্য প্রতিস্থাপন করবে। আপনি কি অবিরত করতে চান?",
    "collabStopOverridePrompt": "অধিবেশন বন্ধ করা আপনার পূর্ববর্তী, স্থানীয়ভাবে সঞ্চিত অঙ্কন ওভাররাইট করবে। আপনি কি নিশ্চিত?\n\n(যদি আপনি আপনার স্থানীয় অঙ্কন রাখতে চান, তাহলে শুধু ব্রাউজার ট্যাবটি বন্ধ করুন।)",
    "errorAddingToLibrary": "বস্তুটি সংগ্রহে যোগ করা যায়নি",
    "errorRemovingFromLibrary": "বস্তুটি সংগ্রহ থেকে বিয়োগ করা যায়নি",
    "confirmAddLibrary": "এটি আপনার সংগ্রহে {{numShapes}} আকার(গুলি) যোগ করবে। আপনি কি নিশ্চিত?",
    "imageDoesNotContainScene": "এই ছবিতে কোনো দৃশ্যের তথ্য আছে বলে মনে হয় না৷ আপনি কি নিবদ্ধ করার সময় দৃশ্য এমবেডিং করতে সক্ষম?",
    "cannotRestoreFromImage": "এই ফাইল থেকে দৃশ্য পুনরুদ্ধার করা যায়নি",
    "invalidSceneUrl": "সরবরাহ করা লিঙ্ক থেকে দৃশ্য লোড করা যায়নি৷ এটি হয় বিকৃত, অথবা বৈধ এক্সক্যালিড্র জেসন তথ্য নেই৷",
    "resetLibrary": "এটি আপনার সংগ্রহ পরিষ্কার করবে। আপনি কি নিশ্চিত?",
    "removeItemsFromsLibrary": "সংগ্রহ থেকে {{count}} বস্তু বিয়োগ করা হবে। আপনি কি নিশ্চিত?",
    "invalidEncryptionKey": "অবৈধ এনক্রীপশন কী।",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "অসমর্থিত ফাইল।",
    "imageInsertError": "ছবি সন্নিবেশ করা যায়নি। পরে আবার চেষ্টা করুন...",
    "fileTooBig": "ফাইলটি খুব বড়। সর্বাধিক অনুমোদিত আকার হল {{maxSize}}৷",
    "svgImageInsertError": "এসভীজী ছবি সন্নিবেশ করা যায়নি। এসভীজী মার্কআপটি অবৈধ মনে হচ্ছে৷",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "কোল্যাব সার্ভারের সাথে সংযোগ করা যায়নি। পৃষ্ঠাটি পুনরায় লোড করে আবার চেষ্টা করুন।",
    "importLibraryError": "সংগ্রহ লোড করা যায়নি",
    "saveLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "বাছাই",
    "lasso": "",
    "image": "চিত্র সন্নিবেশ",
    "rectangle": "আয়তক্ষেত্র",
    "diamond": "রুহিতন",
    "ellipse": "উপবৃত্ত",
    "arrow": "তীর",
    "line": "রেখা",
    "freedraw": "কলম",
    "text": "লেখা",
    "library": "সংগ্রহ",
    "lock": "আঁকার পরে নির্বাচিত টুল সক্রিয় রাখুন",
    "penMode": "",
    "link": "",
    "eraser": "ঝাড়ন",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "ক্যানভাস কার্যকলাপ",
    "selectedShapeActions": "বাছাই করা আকার(গুলি)র কার্যকলাপ",
    "shapes": "আকার(গুলি)"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "একাধিক বিন্দু শুরু করতে ক্লিক করুন, একক লাইনের জন্য টেনে আনুন",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "ক্লিক করুন এবং টেনে আনুন, আপনার কাজ শেষ হলে ছেড়ে দিন",
    "text": "বিশেষ্য: আপনি নির্বাচন টুলের সাথে যে কোনো জায়গায় ডাবল-ক্লিক করে পাঠ্য যোগ করতে পারেন",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "আপনার নিজস্ব সংগ্রহ প্রকাশ করুন",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "প্রিভিউ দেখাতে অপারগ",
    "canvasTooBig": "ক্যানভাস অনেক বড়।",
    "canvasTooBigTip": "বিশেষ্য: দূরতম উপাদানগুলোকে একটু কাছাকাছি নিয়ে যাওয়ার চেষ্টা করুন।"
  },
  "errorSplash": {
    "headingMain": "একটি ত্রুটির সম্মুখীন হয়েছে৷ চেষ্টা করুন <button>পৃষ্ঠাটি পুনরায় লোড করার।</button>",
    "clearCanvasMessage": "যদি পুনরায় লোড করা কাজ না করে, চেষ্টা করুন <button>ক্যানভাস পরিষ্কার করার।</button>",
    "clearCanvasCaveat": " এর ফলে কাজের ক্ষতি হবে ",
    "trackedToSentry": "ত্রুটি {{eventId}} আমাদের সিস্টেমে ট্র্যাক করা হয়েছিল।",
    "openIssueMessage": "আমরা ত্রুটিতে আপনার দৃশ্যের তথ্য অন্তর্ভুক্ত না করার জন্য খুব সতর্ক ছিলাম। আপনার দৃশ্য ব্যক্তিগত না হলে, আমাদের অনুসরণ করার কথা বিবেচনা করুন <button>ত্রুটি ইতিবৃত্ত।</button> অনুগ্রহ করে GitHub ইস্যুতে অনুলিপি এবং পেস্ট করে নীচের তথ্য অন্তর্ভুক্ত করুন।",
    "sceneContent": "দৃশ্য বিষয়বস্তু:"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "সেশন শুরু করুন",
    "button_stopSession": "সেশন বন্ধ করুন",
    "desc_inProgressIntro": "লাইভ-সহযোগীতার সেশন এখন চলছে।",
    "desc_shareLink": "আপনি যার সাথে সহযোগিতা করতে চান তাদের সাথে এই লিঙ্কটি ভাগ করুন: ",
    "desc_exitSession": "অধিবেশন বন্ধ করা আপনাকে রুম থেকে সংযোগ বিচ্ছিন্ন করবে, কিন্তু আপনি স্থানীয়ভাবে দৃশ্যের সাথে কাজ চালিয়ে যেতে সক্ষম হবেন। মনে রাখবেন যে এটি অন্য লোকেদের প্রভাবিত করবে না এবং তারা এখনও তাদের সংস্করণে সহযোগিতা করতে সক্ষম হবে।",
    "shareTitle": "এক্সক্যালিড্র লাইভ সহযোগিতা সেশনে যোগ দিন"
  },
  "errorDialog": {
    "title": "ত্রুটি"
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "নিবদ্ধ",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "ক্লিক",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "অথবা",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "কোণ",
    "shapes": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": "প্রস্থ"
  },
  "toast": {
    "addedToLibrary": "সংগ্রহশালায় যুক্ত হয়েছে",
    "copyStyles": "",
    "copyToClipboard": "ক্লিপবোর্ডে কপি করা হয়েছে।",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "বাছাই",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
